'use strict';

var _this;
class gamingTool {

    constructor(gamingComponent) {

        _this = this;

        this.container = gamingComponent;

        this.settings = JSON.parse(atob(window.gaming));

        this.timer = parseInt(this.settings.timer);
        this.timerInterval;

        this.countdown = this.container.find('.countdown');
        this.headerGame = this.container.find('.header-game');
        this.questionWrapper = this.container.find('.game-play');
        this.allQuestion = this.container.find('.question');
        this.closeBtn = this.container.find('.close-game a');
        this.restartBtn = this.container.find('.button.restart');
        this.resultContainer = this.container.find('.result');
        this.steps = this.container.find('.steps');

        this.changing = false;
        this.msFade = 500;
        this.index = 0;
        this.collection = [];

        _this.shuffle();
        _this.attachClickListener();
        _this.countdown.html((this.timer < 10 ? '0' + this.timer : this.timer) + ':00');

    }

    debug() {
        console.log(_this);
        console.log(_this.findMostFrequest(_this.collection));
    }

    attachClickListener() {
        // Start
        _this.questionWrapper.on('click keypress', 'div.button.start', function(e) {
            if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
                _this.next();
            }
        });

        // Domande
        // vechia versione: ho dovuto spostare il focus sulla label
            // _this.questionWrapper.on('click keypress', 'input[type="radio"]', function(e) {
            //     if ((e.type === 'click') || (e.type === 'keypress' && e.key === 'Enter')){
            //         console.log(e.target);
            // //         if (!_this.changing) {
            // //             _this.changing = true;
            // //             console.log(e.target.attributes.typeof.value);
                        
            // //             _this.collection.push(e.target.attributes.typeof.value);
            // //             setTimeout(() => {
            // //                 _this.next();
            // //             }, 100);
            // //         } else {
            // //             e.preventDefault();
            // //         }
            //     }
            // });

        _this.questionWrapper.on('click keypress', '.radio-label', function(e) {
            if (e.type === 'click' || (e.type === 'keypress' && (e.key === 'Enter' || e.key === ' ')&& e.target.tagName.toLowerCase() === 'label') ) {
                let element = $(this).find('input[type="radio"]');
                if (!_this.changing) {
                    _this.changing = true;
                    _this.collection.push(element.attr('typeof'));
                    element[0].checked = true;
                    setTimeout(() => {
                        _this.next();
                        let next_request_id = '#' + $(this).attr('next-request');
                        let $next_request = $(next_request_id);

                        if ($next_request.is(':visible')) {
                            $next_request.attr('tabindex', '-1').focus();
                        }
                    }, 100);
                } else {
                    e.preventDefault();
                }
            }
        });
        

        // Restart
        _this.restartBtn.on('click', function() {
            _this.updateSteps(0);
            _this.jump(1);
        });

        // Close
        _this.closeBtn.on('click', function(e) {
            e.preventDefault();
            _this.timerStop();
            _this.hideHeader();
            _this.hideSteps();
            _this.jump(0);
        });
    }

    next() {
        if (_this.questionWrapper.children().eq(_this.index + 1).is('.result')) {
            _this.fillResult();
            _this.timerStop();
            _this.hideSteps();
            // _this.debug();
        }
        _this.questionWrapper.children().eq(_this.index).fadeOut(_this.msFade, function() {
            if (_this.questionWrapper.children().eq(_this.index + 1).hasClass('question')) {
                _this.updateSteps(_this.index);
            }
            _this.index++;
            if (_this.questionWrapper.children().eq(_this.index).is('.question:first')) {
                _this.timerStart();
                _this.showHeader();
                _this.showSteps();
            }
            window.scrollTo(0,0);
            _this.questionWrapper.children().eq(_this.index).fadeIn(_this.msFade);
            _this.changing = false;
        });
    }

    fillResult() {
        let mostRespType = _this.findMostFrequest(_this.collection);
        let resultObj = _this.settings.results[mostRespType];
        _this.resultContainer.find('.result-title').html(resultObj.titolo);
        _this.resultContainer.find('.result-text').html(resultObj.testo);
        _this.resultContainer.find('.result-img').attr('src', resultObj.immagine.url);
        _this.resultContainer.find('.result-img').attr('alt', resultObj.immagine.alt);
        if (resultObj.cta.length > 0) {
            resultObj.cta.forEach(cta => {
                let target = '';
                if (cta.cta.target.length) {
                    target = 'target="' + cta.cta.target + '"';
                }
                let link = '<a href="' + cta.cta.url + '" class="button button-red" ' + target + '>' + cta.cta.title + '</a>';
                _this.resultContainer.find('.game-result-buttons').prepend(link);
            });
        }
    }

    findMostFrequest(arr) {
        let compare = '';
        let mostFreq = '';
        arr.reduce((acc, val) => {
            if(val in acc){        
                acc[val]++;
            } else {
                acc[val] = 1;
            }
            if(acc[val] > compare){ 
                compare = acc[val];
                mostFreq = val;
            }
                return acc;
            }, {})
        return mostFreq;
    }

    clearResult() {
        _this.resultContainer.find('.result-title').html('');
        _this.resultContainer.find('.result-text').html('');
        _this.resultContainer.find('.result-img').attr('src', '');
        _this.resultContainer.find('.game-result-buttons').find('*').not('.restart').remove();
    }

    timerStart() {
        _this.countdown.fadeIn(_this.msFade);

        let duration = _this.timer * 60;
        // let duration = 20;
        let timer = duration, minutes, seconds;

        function time() {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            let calcBar = timer * (100 / duration) + '%';
            // _this.countdown.animate({ width: calcBar }, _this.msFade, 'linear');
            _this.countdown.css('width', calcBar).html(minutes + ':' + seconds);

            if (timer == 0) {
                _this.timerStop();
                _this.jump(0);
                _this.shuffle();
                _this.hideSteps();
                _this.hideHeader();
            } else if (--timer < 0) {
                timer = duration;
            }
        }

        time();
        _this.timerInterval = setInterval(time, 1000);

    }

    timerStop() {
        _this.countdown.fadeOut(_this.msFade, function() {
            _this.countdown.html((_this.timer < 10 ? '0' + _this.timer : _this.timer) + ':00');
            _this.countdown.css('width', '100%');
        });
        clearInterval(_this.timerInterval);
    }

    jump(index) {
        _this.questionWrapper.children().eq(_this.index).fadeOut(_this.msFade, function() {
            _this.questionWrapper.find('form').trigger('reset');
            _this.shuffle();
            _this.clearResult();
            _this.collection = [];
            _this.index = index;
            if (_this.index == 1) {
                _this.timerStart();
                _this.showSteps();
                _this.showHeader();
            }
            _this.questionWrapper.children().eq(_this.index).fadeIn(_this.msFade);
        });
    }

    showSteps() {
        _this.steps.css('display', 'flex').hide().fadeIn(_this.msFade);
    }

    hideSteps() {
        _this.steps.fadeOut(_this.msFade, function() {
            _this.updateSteps(1);
        });
    }

    updateSteps(index) {
        _this.steps.children().removeClass('active');
        _this.steps.children().eq(index).addClass('active');
    }

    shuffle() {
        window.scrollTo(0,0);
        _this.allQuestion.each(function() {
            let respContainer = $(this).find('.risposte form');
            let allResp = respContainer.find('label');
            while (allResp.length) {
                respContainer.append(allResp.splice(Math.floor(Math.random() * allResp.length), 1)[0]);
            }
        });
    }

    showHeader() {
        _this.headerGame.fadeIn(_this.msFade);
    }

    hideHeader() {
        _this.headerGame.fadeOut(_this.msFade);
    }
}

export default gamingTool;


// WEBPACK FOOTER //
// ./scripts/components/gamingTool.js